/**
 * src/utils/msalConfig.js
 *
 * Configuración base para conectarte a un tenant de Azure AD B2C usando MSAL.
 */
import { LogLevel, PublicClientApplication } from "@azure/msal-browser";

/**
 * Políticas o User Flows de tu tenant B2C
 */
export const b2cPolicies = {
  names: {
    signUpSignIn: "B2C_1_signin_signup",
    passwordReset: "B2C_1_pass_reset"
  },
  authorities: {
    signUpSignIn: {
      authority: "https://deepextractions.b2clogin.com/deepextractions.onmicrosoft.com/B2C_1_signin_signup"
    },
    passwordReset: {
      authority: "https://deepextractions.b2clogin.com/deepextractions.onmicrosoft.com/B2C_1_pass_reset"
    }
  },
  authorityDomain: "deepextractions.b2clogin.com"
};

/**
 * Configuración principal para MSAL
 */
export const msalConfig = {
  auth: {
    clientId: "7d1e670c-aad4-4b5a-821e-a2d79bcde42e",
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: process.env.REACT_APP_BASE_URL,
    postLogoutRedirectUri: "/"
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false
  },
  system: {
    allowNativeBroker: false,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            if (process.env.REACT_APP_API_LOG_ENDPOINT === "true") {
              console.error(message);
            }
            break;
          case LogLevel.Info:
            if (process.env.REACT_APP_API_LOG_ENDPOINT === "true") {
              console.info(message);
            }
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          default:
            break;
        }
      }
    }
  }
};

/**
 * Scopes solicitados durante el login
 */
export const loginRequest = {
  scopes: [
    "https://deepextractions.onmicrosoft.com/3c98d832-da8b-410d-889c-b8c769452a7c/Task.Write"
  ]
};

/**
 * Configuración de tu API (para utilizar un token válido al llamar)
 */
export const apiConfig = {
  scopes: [
    "https://deepextractions.onmicrosoft.com/3c98d832-da8b-410d-889c-b8c769452a7c/Task.Write"
  ],
  uri: process.env.REACT_APP_BASE_URL
};

// Crear instancia MSAL
export const msalInstance = new PublicClientApplication(msalConfig);

/**
 * Inicializa la autenticación con manejo de password reset (AADB2C90118)
 */
export const handleRedirect = async () => {
  try {
    const response = await msalInstance.handleRedirectPromise();

    if (!response) {
      // No hay sesión activa, se inicia login por redirección
      await msalInstance.loginRedirect(loginRequest);
    } else {
      console.log("Successful login:", response);
    }

  } catch (error) {
    if (
      error.errorMessage &&
      error.errorMessage.includes("AADB2C90118")
    ) {
      // Usuario hizo clic en "Forgot your password?"
      const passwordResetRequest = {
        authority: b2cPolicies.authorities.passwordReset.authority,
        scopes: loginRequest.scopes
      };

      await msalInstance.loginRedirect(passwordResetRequest);
    } else {
      console.error("Authentication error:", error);
    }
  }
};
